var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.819092,
    width: 64,
    height: 64,
    rx: 10.24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3075 44.7057H49.8035L33.0707 9.09888H27.3734V9.37222C29.0809 10.4437 29.2033 11.9261 28.1742 14.4202L14.1967 44.7057H18.0578L22.7239 34.0392H39.575L44.3075 44.7057ZM23.9079 31.1841L31.0209 14.9582L38.2431 31.1841H23.9079Z",
    fill: "#133F7A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6709_63726)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 49,
    width: 6,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1027 49.8375V50.3768H53.7128V52.7357H56.7283V53.2617H53.7128V55.9867H57.3141V56.5777H52.8206V49.8375H57.1027Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4158 48.4332H58.7176V57.9818H51.4158V48.4332Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 49,
    width: 7,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7579 49.8375L42.0595 55.54L44.306 49.8375H44.9573L42.2099 56.5777H41.5586L38.7787 49.8375H39.7579Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3737 48.4332H46.3606V57.9818H37.3737V48.4332Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 49,
    width: 6,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0724 49.7051C29.6056 49.7051 30.3722 49.8548 30.8127 50.0187V50.7138L30.7944 50.7287C30.3489 50.3349 29.5854 50.1917 28.9393 50.1917C27.4156 50.1917 26.2024 51.3509 26.2024 53.1747C26.2024 55.3475 27.5251 56.1985 29.069 56.2119C29.6941 56.2165 30.5137 56.1011 30.9836 55.6042L30.9985 55.6199V56.4739C30.4252 56.6393 29.6319 56.7913 29.0274 56.7901C27.112 56.7817 25.2576 55.6718 25.2576 53.2759C25.2576 51.475 26.6802 49.7051 29.0724 49.7051Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8544 48.3008H32.4036V58.1943H23.8544V48.3008Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 49,
    width: 6,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2261 49.8633V54.2243C33.2261 55.212 33.5434 56.2734 35.0576 56.2734C36.4829 56.2734 37.0977 55.4252 37.0977 54.1682V49.8633H37.7197V54.1487C37.7197 55.6207 36.7533 56.7891 35.061 56.7891C33.3699 56.7891 32.3309 55.7636 32.3309 54.2705V49.8633H33.2261Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9261 48.4589H39.1233V58.1931H30.9261V48.4589Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 49,
    width: 8,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0338 49.8141L25.1098 56.6303H24.0995L23.2295 54.5881H20.1318L19.2744 56.6303H18.5642L21.1337 50.8324C21.3233 50.3554 21.3004 50.0712 20.9865 49.8665V49.8141H22.0338ZM21.6684 50.9294L20.3534 54.0625H23.0041L21.6684 50.9294Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1592 48.41H26.5132V58.0346H17.1592V48.41Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 49,
    width: 7,
    height: 8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8131 49.8633V54.2243C46.8131 55.212 47.1308 56.2734 48.6446 56.2734C50.0698 56.2734 50.6847 55.4252 50.6847 54.1682V49.8633H51.3071V54.1487C51.3071 55.6207 50.3403 56.7891 48.6484 56.7891C46.9576 56.7891 45.9187 55.7636 45.9187 54.2705V49.8633H46.8131Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5138 48.4589H52.7106V58.1931H44.5138V48.4589Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 49,
    width: 7,
    height: 8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45102 49.8315L9.52355 55.3448H9.56054L11.6701 49.8315H12.9108V56.5602H12.0743V52.4226C12.0743 51.9623 12.0961 51.378 12.1388 50.6687H12.1018L9.85918 56.5602H9.16541L6.94986 50.6599H6.91325C6.95939 51.1507 6.9819 51.7569 6.9819 52.478V56.5602H6.20117V49.8315H7.45102Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79785 48.4275H14.3159V57.9646H4.79785V48.4275Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 51,
    width: 6,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7217 51.5065L15.8114 54.3829C16.041 55.0093 16.1817 55.4676 16.234 55.7594H16.271C16.2984 55.646 16.361 55.4332 16.4594 55.122C16.5574 54.8103 16.6398 54.5613 16.7073 54.3741L17.7325 51.5065H18.6238L16.4498 57.2597C16.2385 57.8181 15.9876 58.2184 15.6962 58.4609C15.4052 58.7034 15.0451 58.8245 14.6161 58.8245C14.3861 58.8245 14.158 58.7985 13.9315 58.7462V58.0881C14.0844 58.1248 14.2686 58.1435 14.483 58.1435C14.7465 58.1435 14.9704 58.0706 15.1538 57.925C15.3377 57.7791 15.4879 57.5542 15.6043 57.2505L15.8663 56.5783L13.835 51.5065H14.7217Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4316 50.1023H20.0289V60.2288H12.4316V50.1023Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6709_63726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 49,
    width: 5,
    height: 5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2081 49.392C60.7975 49.392 61.298 49.5985 61.711 50.0121C62.1227 50.4257 62.3289 50.9237 62.3289 51.5075C62.3289 52.0918 62.1227 52.5873 61.711 52.9944C61.298 53.4002 60.7975 53.6047 60.2081 53.6047C59.618 53.6047 59.1181 53.4002 58.7051 52.9944C58.2915 52.5873 58.0859 52.0918 58.0859 51.5075C58.0859 50.9237 58.2915 50.4257 58.7051 50.0121C59.1181 49.5985 59.618 49.392 60.2081 49.392ZM60.2081 49.718C59.7121 49.718 59.29 49.8939 58.9418 50.2452C58.5943 50.5958 58.4205 51.0172 58.4205 51.5075C58.4205 51.9983 58.5962 52.4191 58.9463 52.7697C59.2977 53.121 59.7179 53.2976 60.2081 53.2976C60.6976 53.2976 61.1184 53.121 61.4685 52.7697C61.8199 52.4191 61.9937 51.9983 61.9937 51.5075C61.9937 51.0172 61.8206 50.5958 61.4737 50.2452C61.1255 49.8939 60.7041 49.718 60.2081 49.718ZM60.2165 50.3056C60.4648 50.3056 60.6743 50.3621 60.8454 50.4777C61.0153 50.5926 61.1009 50.7679 61.1009 51.0043C61.1009 51.3523 60.9181 51.5665 60.5524 51.6477L61.1943 52.6905H60.673L60.1147 51.6938H59.808V52.6905H59.3801V50.3056H60.2165ZM60.1983 50.6686H59.808V51.349H60.1517C60.4992 51.349 60.673 51.2309 60.673 50.9952C60.673 50.777 60.5148 50.6686 60.1983 50.6686Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6709_63726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6824 47.9878H63.7338V55.0089H56.6824V47.9878Z",
    fill: "#133F7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6709_63726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.1682,
    height: 9.5486,
    fill: "white",
    transform: "translate(6.20105 49.2759)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.ed9b450119ccbf4510ec44f50a7aac3d.svg";
export { ForwardRef as ReactComponent };